export default "__VITE_ASSET__DolRfgID__"